import { Box, IconButton, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import VisitChatRoom from '../../visit/components/VisitChatRoom';
import { useConversationModalContext } from '../hooks/useConversationModalContext';
import useRoomState from '../hooks/useRoomState';
import ToggleAudioButton from './ToggleAudioButton';
import ToggleVideoButton from './ToggleVideoButton';

export default function ConversationModalFooter() {
  const {
    state: { maximize, conversationId, size },
    onMaximize,
    onMinimize,
    closeModal,
  } = useConversationModalContext();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const theme = useTheme();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'));

  // Determine if modal is narrow (less than 270px)
  const isNarrowModal = size.width < 270;

  // IconButton size styling based on modal width
  const iconButtonSx = isNarrowModal
    ? { width: 30, height: 30, minWidth: 30, minHeight: 30 }
    : {};

  const endConversation = () => {
    closeModal();
  };

  return (
    <>
      <Stack
        sx={{
          p: isDownLg ? 1 : 2,
          flexDirection: 'row',
          justifyContent: 'space-between',
          '@media (min-width:600px) and (max-height:420px)': { p: 1 },
          position: 'relative',
        }}
      >
        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'flex-start' }}>
          <IconButton
            size="small"
            sx={{
              ...iconButtonSx,
              backgroundColor: theme.palette.grey[300],
            }}
            onClick={maximize ? onMinimize : onMaximize}
          >
            <Iconify
              icon={
                maximize
                  ? 'material-symbols:close-fullscreen'
                  : 'material-symbols:fullscreen'
              }
            />
          </IconButton>
        </Box>
        <Stack
          direction="row"
          gap={isDownLg ? 1 : 2}
          sx={{ display: 'flex', flex: 1, justifyContent: 'center' }}
        >
          <ToggleAudioButton disabled={isReconnecting} sx={iconButtonSx} />
          <IconButton
            size="small"
            sx={{
              ...iconButtonSx,
              backgroundColor: theme.palette.error.main,
              ':hover': {
                backgroundColor: theme.palette.error.light,
              },
            }}
            onClick={endConversation}
          >
            <Iconify
              icon="fluent:call-end-24-filled"
              color={theme.palette.text.primary}
            />
          </IconButton>
          <ToggleVideoButton disabled={isReconnecting} sx={iconButtonSx} />
          {/* <IconButton
            size="small"
            sx={{
              backgroundColor: theme.palette.primary.main,
              ':hover': {
                backgroundColor: theme.palette.primary.dark,
              },
              '&:disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
              },
            }}
            disabled={isReconnecting}
            onClick={() => setIsChatOpen(!isChatOpen)}
          >
            <Iconify
              icon="material-symbols:chat"
              color={theme.palette.common.white}
            />
          </IconButton> */}
        </Stack>
        <Box
          sx={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}
        ></Box>
      </Stack>

      {conversationId && (
        <VisitChatRoom
          conversationId={conversationId}
          isOpen={isChatOpen}
          onClose={() => setIsChatOpen(false)}
          variant="drawer"
        />
      )}
    </>
  );
}
